import { render, staticRenderFns } from "./StatisticTable.vue?vue&type=template&id=7c2425be&scoped=true"
import script from "./StatisticTable.vue?vue&type=script&lang=js"
export * from "./StatisticTable.vue?vue&type=script&lang=js"
import style0 from "./StatisticTable.vue?vue&type=style&index=0&id=7c2425be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2425be",
  null
  
)

export default component.exports